function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { MenuItem as MUIMenuItem } from "@mui/material";
const MenuItemForwardRef = props => /*#__PURE__*/React.createElement(MUIMenuItem, _extends({
  sx: {
    "& a": {
      textDecoration: "none",
      color: "inherit"
    },
    "& a:hover": {
      color: "inherit"
    }
  }
}, props));
export const MenuItem = props => /*#__PURE__*/React.createElement(MenuItemForwardRef, props);
export default MenuItem;